
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 18.06v-7.43a7 7 0 1113.94 0v7.43M17.68 11.51v6.28M22.32 11.51v6.28M13.07 11.62h13.86M8.41 23.57H31.6v15.18H8.41z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M16.6 38.72v-7.58a3.4 3.4 0 116.8 0v7.58M8.49 25.75H1.5v13h6.92M31.51 25.75h6.99v13h-6.92M29.42 23.21V18.2H10.58v5.01M20 0v3.37","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    